<template>
  <div>
    <h4>Настройки поиска</h4>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <DatePicker v-model="filter.date" :min="$date().format('YYYY-MM-DD')" />
      </v-col>
    </v-row>

    <v-row class="search-list">
      <v-col>
        <v-autocomplete
          clearable
          placeholder="Специализация"
          item-text="name"
          item-value="id"
          v-model="filter.specialization"
          :items="specializations"
        />
      </v-col>

      <v-col>
        <v-autocomplete
          clearable
          placeholder="Клиника"
          item-text="name"
          item-value="id"
          v-model="filter.clinic"
          :items="clinics"
        />
      </v-col>

      <v-col>
        <v-select
          clearable
          placeholder="Способ оказания услуги"
          item-text="name"
          item-value="id"
          v-model="filter.service_method"
          :items="serviceProvidingWays"
        />
      </v-col>

      <v-col>
        <v-autocomplete placeholder="Врач" item-text="fullName" item-value="fullName" v-model="filter.doctor" :items="doctors" />
      </v-col>

      <v-col>
        <v-select clearable label="Сортировать" :items="select"></v-select>
      </v-col>

      <v-col md="auto">
        <v-btn class="mr-0" color="primary" @click="onReset">Сбросить</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from "@/components/forms/DatePicker.vue";
import { ReferencesRepository } from "@/modules/references/references.repository.js";
import { Doctor } from "@/modules/doctors/Doctor.js";

export default {
  name: "AppointmentSearch",

  components: { DatePicker },

  props: {
    /** @type {import("vue").PropOptions<Doctor[]>} */
    doctors: {
      type: Array,
      required: true,
    },

    value: Object,
  },

  data() {
    return {
      select: ["По наибольшему стажу", "По наибольшему рейтингу", "По наибольшему кол-ву отзывов"],
      /** @type {Reference.Clinic[]} */
      clinics: [],
      /** @type {Reference.ServiceProvidingWay[]} */
      serviceProvidingWays: [],
      /** @type {Reference.Specialization[]} */
      specializations: [],
      filter: {
        date: null,
        minDate: this.$route.query.minDate || null,
        clinic: null,
        doctor: null,
        service: null,
        service_method: null,
        specialization: this.$route.query.specialization ? Number(this.$route.query.specialization) : null,
        sort: null,
      },
      pagination: {
        total: 1,
      },
    };
  },

  computed: {},

  watch: {
    filter: {
      deep: true,
      handler(newVal) {
        this.$emit("input", { ...newVal });
      },
    },
  },

  async created() {
    await this.loadReferences();
  },

  methods: {
    async loadReferences() {
      const [clinics, serviceProvidingWays, specializations] = await Promise.all([
        await ReferencesRepository.clinics({ hasDoctors: true }),
        await ReferencesRepository.serviceProvidingWays(),
        await ReferencesRepository.specializations(),
      ]);
      this.clinics = clinics;
      this.serviceProvidingWays = serviceProvidingWays;
      // this.services = services;
      this.specializations = specializations;
    },

    onReset() {
      this.filter = {
        date: null,
        clinic: null,
        doctor: null,
        service: null,
        service_method: null,
        specialization: null,
        sort: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .search-list {
    .col {
      flex-basis: auto;
      max-width: 33%;
    }
  }
}

@media screen and (max-width: 599px) {
  .search-list {
    .col {
      max-width: 50%;
    }
  }
}

@media screen and (max-width: 480px) {
  .search-list {
    .col {
      max-width: 100%;
    }
  }
}
</style>
